// @flow

import React from 'react';

import ElapsedTime from 'app/components/general/ElapsedTime';
import {ActionsButton} from 'app/general/widgets/ActionsButton';
import {gt} from 'app/utils/i18n';

import {WebHookSerializedType} from 'sweet-types';

type Props = {
  webhook: WebHookSerializedType;
  remove: (webhook: WebHookSerializedType) => Promise<unknown>;
  update: (webhook: WebHookSerializedType) => Promise<unknown>;
};

export const WebhookItem = ({webhook, remove, update}: Props): JSX.Element => (
  <div className="row py-2 border-bottom">
    {/* mobile */}
    <div className="d-sm-none col-12 d-block form-check">
      <input
        type="checkbox"
        checked={webhook.is_active}
        onChange={(event) =>
          update({...webhook, is_active: event.target.checked})
        }
      />
      <span className="form-check-label font-weight-bold ml-1">
        {gt('Active')}
      </span>
    </div>
    <div className="d-sm-none col-12">
      <div className="form-group row mb-0">
        <div className="col-2 col-form-label font-weight-bold">
          {gt('Event')}
        </div>
        <div className="col d-flex align-items-center">
          <span className="badge badge-primary">{webhook.event}</span>
        </div>
      </div>
    </div>
    <div className="d-sm-none col-12">
      <div className="form-group row mb-0">
        <div className="col-12 col-form-label font-weight-bold">
          {gt('Target URL')}
        </div>
        <div className="col-12 text-wrap text-truncate">{webhook.target}</div>
      </div>
    </div>
    <div className="d-none d-sm-flex col-2 pr-0 align-items-center justify-content-center">
      <input
        type="checkbox"
        checked={webhook.is_active}
        onChange={(event) =>
          update({...webhook, is_active: event.target.checked})
        }
      />
    </div>

    {/* desktop */}
    <div className="d-none d-sm-flex col-3 pr-0 align-items-center">
      <span className="badge badge-primary">{webhook.event}</span>
    </div>
    <div className="d-none d-sm-block col-sm-4 pr-0 text-truncate">
      {webhook.target}
    </div>
    <div className="d-none d-sm-block col-12 col-sm-2 pr-0 text-truncate">
      <ElapsedTime timestamp={webhook.created_at} />
    </div>

    {/* shared */}
    <div className="col-auto col-sm-1 ml-auto">
      <ActionsButton
        actions={[
          {
            text: gt('Remove webhook'),
            icon: 'text-danger fa-fw fa fa-times',
            key: 'remove',
            callback: () => remove(webhook),
          },
        ]}
      />
    </div>
  </div>
);
